import { Reveal } from "./Reveal";
import { GoldRule } from "./ornaments";

const frames = [
  {
    src: "https://images.unsplash.com/photo-1511229577011-6b24bfc30871?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format&fit=crop&w=800",
    alt: "Golden champagne coupes raised for a toast",
  },
  {
    src: "https://images.unsplash.com/photo-1764776709859-09e142936d1c?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format&fit=crop&w=800",
    alt: "Crystal chandeliers in a grand hall",
  },
  {
    src: "https://images.unsplash.com/photo-1765351806980-a2a452d6e2e5?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format&fit=crop&w=800",
    alt: "Elegant table setting with champagne glasses and white linens",
  },
];

export const Spotlight = () => (
  <section className="relative overflow-hidden bg-navy py-24 sm:py-32" data-testid="spotlight-section">
    <div className="pointer-events-none absolute inset-0" aria-hidden="true">
      <div className="absolute right-[-15%] top-[10%] h-[60vh] w-[45vw] rounded-full bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.08),transparent_65%)]" />
    </div>

    <div className="relative mx-auto grid max-w-7xl items-center gap-16 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20">
      <div className="relative order-2 lg:order-1">
        <Reveal>
          <div className="relative mx-auto w-72 sm:w-80 lg:w-[340px]">
            <div className="overflow-hidden rounded-t-full border border-gold/35 pb-3 gold-glow-soft" data-testid="spotlight-main-frame">
              <div className="overflow-hidden rounded-t-full">
                <img
                  src={frames[0].src}
                  alt={frames[0].alt}
                  className="aspect-[3/4] w-full object-cover saturate-[0.9] contrast-105 transition-transform duration-[1.8s] ease-out hover:scale-105"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="absolute -bottom-10 -left-10 sm:-left-20 w-36 sm:w-44 overflow-hidden rounded-t-full border border-gold/35 bg-navy p-1.5 shadow-2xl">
              <img src={frames[1].src} alt={frames[1].alt} className="aspect-[3/4] w-full rounded-t-full object-cover saturate-[0.9]" loading="lazy" />
            </div>
            <div className="absolute -right-6 top-8 sm:-right-14 w-28 sm:w-32 overflow-hidden rounded-t-full border border-gold/35 bg-navy p-1.5 shadow-2xl">
              <img src={frames[2].src} alt={frames[2].alt} className="aspect-[3/4] w-full rounded-t-full object-cover saturate-[0.9]" loading="lazy" />
            </div>
          </div>
        </Reveal>
      </div>

      <div className="order-1 lg:order-2">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.4em] text-gold">La Diplômée</p>
          <h2 className="mt-5 font-serif text-4xl font-medium leading-[1.1] text-ivory sm:text-5xl lg:text-6xl">
            She did it —
            <span className="text-gold-foil italic"> Dr. Stephanie Darilus</span>
          </h2>
          <p className="mt-5 inline-block rounded-full border border-gold/30 bg-navy/60 px-5 py-2.5 text-[10px] uppercase tracking-[0.25em] text-gold-light sm:text-[11px]" data-testid="spotlight-degree">
            Doctorate in Business Administration · Florida International University
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-7 max-w-xl text-base font-light leading-relaxed text-mist sm:text-lg">
            Years of late nights, long chapters and sheer determination — and now a doctorate to
            show for it. We're getting everyone together to celebrate properly, and we'd love for
            you to be there.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-9 font-script text-3xl text-gold-light sm:text-4xl" data-testid="spotlight-values">
            un verre pour la diplômée
          </p>
          <GoldRule className="mt-10 justify-start" />
        </Reveal>
      </div>
    </div>
  </section>
);

